export default __webpack_public_path__ + "static/media/btn-trash.7b31fbbb.svg";